export function isDesktop () {
    let width = window.innerWidth;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return !isMobile && (width >= 768 && width !== 812)
  }